<template>

  <b-row>
    <b-col cols="10" class="mb-2">
      <h4 class="mb-0">
        Titulares
      </h4>

    </b-col>


    <div class=" col-12">

      <b-row v-if="seguro && !pacienteSeDaCobertura" class="mb-2">

        <h5 class="col-12">Agregar titular</h5>

        <b-col md="6">
          <SearchOpts 
            v-model="titularSearch" 
            :searchService="personasService.searchByQuery"
            :placeholder="'Buscar titular por nombre o numero de cedula...'" 
            :omit="omitTitulares" 
          />
        </b-col>

        <div class="mx-1">
          <div class="d-flex align-items-center">
            <label for="" class="mr-1">Da Cobertura:</label>
            <b-form-checkbox 
              v-model="titularTemp.daCobertura" 
              name="check-button" switch 
            />
          </div>
        </div>

        <b-col md="2">
          <div class="d-flex align-items-center">
            <label for="" class="mr-1">Madre soltera:</label>
            <b-form-checkbox 
              v-model="titularTemp.padreSoltero" 
              name="check-button" 
              switch 
            />
          </div>

        </b-col>

        <b-col md="1">
          <b-button 
            variant="info" 
            size="sm" 
            @click="onAddNewTitularSearch()" 
            style="cursor: pointer;"
            title="Seleccionar Titular" class="ml-1"
          >
            <strong>
              <i class="fa-solid fa-check-double"></i>
            </strong>
          </b-button>
        </b-col>

        <b-col md="1">
          <b-button 
            variant="success" 
            size="sm" 
            @click="onRegistrarPersona()" 
            style="cursor: pointer;"
            title="Crear Nueva Persona"
          >
            <strong>
              <i class="fa-solid fa-user-plus mx-1" />
            </strong>
          </b-button>
        </b-col>
      </b-row>

      <b-row>

        <b-alert 
          v-if="showAlertLastTitulares"
          show 
          class="col-12 p-1"
          variant="warning"
        >
          <i class="fa-solid fa-lightbulb mx-1"/>
          Informacion de los titulares cargados de la ultima cita
        </b-alert>

        <b-table 
          v-if="titularesList.length > 0" 
          bordered striped responsive 
          :items="titularesList"
          :fields="fieldsTitulares"
        >
          <template #cell(daCobertura)="data">
            <div class="text-center">
              <i style="font-size: 20px;" :class="data.item.daCobertura
                ? 'fa-solid fa-circle-check text-success'
                : 'fa-solid fa-circle-xmark text-danger'" />
            </div>
          </template>

          <template #cell(padreSoltero)="data">
            <div class="text-center">
              <i style="font-size: 20px;" :class="data.item.padreSoltero
                ? 'fa-solid fa-circle-check text-success'
                : 'fa-solid fa-circle-xmark text-danger'" />
            </div>
          </template>

          <template #cell(acciones)="data">
            <div 
              v-if="data.item.cedula != paciente.identificacion" 
              class="d-flex justify-content-center"
            >
              <b-button 
                variant="primary" 
                size="sm" 
                style="cursor: pointer;"
                @click="onEditTitular(data.item)"
              >
                <font-awesome-icon icon="user-pen" style="color: blue;" />
              </b-button>

              <b-button 
                variant="danger" 
                size="sm" 
                style="cursor: pointer;" 
                @click="removeItemTitular(data.item)"
              >
                <font-awesome-icon icon="circle-xmark" style="color: red;" />
              </b-button>
            </div>

          </template>
        </b-table>

        <b-alert 
          v-if="titularesList.length == 0 && !pacienteSeDaCobertura" 
          variant="danger" 
          show class="text-center col-12"
          style="padding: 40px; font-size: 20px;">
          <i class="fa-solid fa-triangle-exclamation" />
          No existe ningun titular registrado
        </b-alert>

        <b-alert 
          v-if="pacienteSeDaCobertura" 
          variant="info" 
          show class="text-center col-12"
          style="padding: 40px; font-size: 20px;">
          <i class="fa-solid fa-person" />
          El paciente es el titular del contrato
        </b-alert>

      </b-row>

    </div>

    <b-modal v-model="visibleModalEditTitular" title="Editar Titular" hide-footer>

      <b-card class="m-0">
        <div class="mb-2">{{ `${titularEdit.cedula} - ${titularEdit.nombre}` }}</div>

        <div class="b-row d-flex align-items-center my-1">
          <label for="" class="mr-1 col-4">Da Cobertura:</label>
          <b-form-checkbox 
            v-model="titularEdit.daCobertura" 
            name="check-button" 
            switch 
          />
        </div>

        <div class="b-row d-flex align-items-center my-1">
          <label for="" class="mr-1 col-4">Es madre soltera:</label>
          <b-form-checkbox 
            v-model="titularEdit.padreSoltero" 
            name="check-button" 
            switch 
          />
        </div>
      </b-card>
    </b-modal>

    <ModalCrearPersona />

  </b-row>

</template>

<script>
import { mapState } from "vuex";
import { BootstrapVue } from 'bootstrap-vue';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import { personasService } from '@/views/admision/services';

import { SearchOpts } from '@/shared/components';
import { calculateAgeWithDateString } from "@/shared/helpers";
import ModalCrearPersona from '@/views/administracion/components/personas/ModalCrearPersona.vue';
import { citasService } from "../../services";



export default {

  name: 'CitaTitulares',

  components: {
    ...BootstrapVue.components,
    SearchOpts, 
    ModalCrearPersona
  },

  props: {

    esCrear:{
      default:false,
      required:false
    },

  },


  created() {
    this.loadDataSave();
    this.loadLastData();
  },


  data() {
    return {
      titularesDeCita:{
        cargoUnaVez:false,
        titulares:null
      },

      showAlertLastTitulares: false,

      fieldsTitulares: [
        { key: 'nombres',      label: 'Nombres',       thClass: 'text-center' },
        { key: 'edad',         label: 'Edad (Años)',   thClass: 'text-center' },
        { key: 'daCobertura',  label: 'Cobertura',     thClass: 'text-center' },
        { key: 'padreSoltero', label: 'Madre soltera', thClass: 'text-center' },
        { key: 'telefono',     label: 'Telefono',      thClass: 'text-center' },
        { key: 'acciones',     label: 'acciones',      thClass: 'text-center', tdClass: 'text-right', sortable: true },
      ],

      titularEdit: {},

      seguro: { esTitular: false },
      showAddTitular: false,
      titularSearch: null,
      personasService,
      omitTitulares: [],

      showDaCobertura: false,
      showPadreSoltero: false,

      titularTemp: {
        daCobertura: false,
        padreSoltero: false
      },

      titularesList: [],

      paciente: {
        identificacion: ''
      },
      visibleModalEditTitular: false,

      codigosCoberturaOtraPersona : ['AG', 'CA', 'CJ', 'CY', 'HJ', 'MH', 'MO', 'AS']

    };
  },



  methods: {


    async loadDataSave(){

      this.tokenCita = this.$route.params.token;
      if(!this.tokenCita) return;

      const responseCita = await citasService.getByToken(this.tokenCita);

      if(!responseCita){
        console.error('Cita no encontrada');
        return;
      }

      const detalles = responseCita.detallescitaSet[0];
      const detalleTitulares = detalles?.detallesTitulares && JSON.parse(detalles?.detallesTitulares);
      // const detalleTitulares = null;
      const detallesSeguros = detalles?.detailsSeguro && JSON.parse(detalles?.detailsSeguro);
      let codigoSeguro = null;

      if(detallesSeguros){
        codigoSeguro = detallesSeguros.seguroSalud.code;
      }
      
      this.titularesList = detalleTitulares || [];
    },


    async loadLastData(){

      this.tokenCita = this.$route.params.token;
      if(this.tokenCita) return;

      const pacienteId = this.stDataPaciente?.id;
      if(!pacienteId) return;

      const params = {
        pacienteId: pacienteId,
      }

      const response = await citasService.getAll(params);
      if(!response) return;

      const citas = response.data;
      const citasFiltradas = citas.filter( c => c.cobSeleccionada.id !== '5');

      if(!citasFiltradas?.length) return;

      const lastDetallesTitulares = citasFiltradas[0].detallescitaSet[0].detallesTitulares;
      if(!lastDetallesTitulares) return;
      const titularesObj = JSON.parse(lastDetallesTitulares);

      console.log('titularesObj', titularesObj);

      if(!titularesObj?.length) return;


      if(!this.codigosCoberturaOtraPersona.includes(this.stDataSeguro?.seguroSalud?.code)) return;
      this.showAlertLastTitulares = true;
      this.titularesList = titularesObj;
    },

    onAddNewTitularSearch() {

      const edad = calculateAgeWithDateString(this.titularSearch.fechaNacimiento)

      const newItem = {
        idPersona       : this.titularSearch.id,
        nombres         : `${this.titularSearch.identificacion} - ${this.titularSearch.primerApellido} ${this.titularSearch.primerNombre}`,
        fechaNacimiento : this.titularSearch.fechaNacimiento,
        telefono        : this.titularSearch.telefono,
        padreSoltero    : this.titularTemp.padreSoltero,
        daCobertura     : this.titularTemp.daCobertura,
        edad,
      };

      this.titularesList = [...this.titularesList, newItem];

      this.titularTemp = { padreSoltero: false, daCobertura: false };
      this.titularSearch = null;
    },


    onRegistrarPersona() {
      this.$router.push({ query: { new_person: true } });
    },

    
    onEditTitular(data) {
      this.visibleModalEditTitular = true;
      this.titularEdit = data;
    },


    async removeItemTitular(item) {

      try {
        const result = await this.$swal({
          title: '¿Estás seguro de eliminar?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, borrar esto!',
          cancelButtonText: 'No, cancelar!',
        });

        if (result.isConfirmed) {

          this.titularesList = this.titularesList.filter( t => t.idPersona !== item.idPersona );



          await this.$swal({
            title: '¡Borrado!',
            text: 'El registro se ha sido eliminado.',
            icon: 'success',
            confirmButtonColor: '#3085d6',
          });

        }
      } catch (error) {
        console.error('Error al eliminar el ítem:', error);
      }
    },

  },

  computed: {
    ...mapState({
      stDataCita        : state => state.citas?.ingresoCitas?.dataInfoCita,
      stDataPaciente    : state => state.citas?.ingresoCitas?.dataInfoCita?.paciente,
      stDataSeguro      : state => state.citas?.ingresoCitas?.dataSeguro,
    }),


    pacienteSeDaCobertura() {
      const codigoSeguro = this.stDataSeguro?.seguroSalud?.code;

      const puedeSerTitular = !this.codigosCoberturaOtraPersona.includes( codigoSeguro);
      return puedeSerTitular
    },
  },


  watch: {

    titularesList: {
      deep: true,
      handler(newValue) {
        this.$store.commit("setDataTitulares", newValue);
      }
    }

  }
}

</script>